import { canAccessParentWindow } from 'common/js/window-ancestors';

export class TrackingDisablingHelper {
  public static isTrackingDisabled(): boolean {
    const ocsInstrument =
      typeof window === 'undefined' ||
      (window as any).ocsInstrument === undefined
        ? {}
        : (window as any).ocsInstrument;

    // When loading the experience through the Demo Page, the "window.parent.parent.isOgyDemoPage" is equal to true (boolean)
    const isRunningInDemoPage =
      canAccessParentWindow(window) &&
      canAccessParentWindow(window.parent) &&
      typeof (parent.parent as any).isOgyDemoPage !== 'undefined';

    // When loading the experience through the Creative Console "preview", the "window.isOgyPreview" is equal to true (boolean)
    const isRunningInCreativeConsolePreview =
      isRunningInDemoPage === false &&
      (typeof window.isOgyPreview !== 'undefined' ||
        (canAccessParentWindow(window) &&
          typeof window.parent.isOgyPreview !== 'undefined'));

    if (
      ocsInstrument.disableEvents === true ||
      isRunningInDemoPage === true ||
      isRunningInCreativeConsolePreview === true
    ) {
      return true;
    }
    return false;
  }
}
